import { Grid, Typography,  Button,
  ButtonGroup,   Box,
  CircularProgress,
} from '@mui/material';
import {
  Movie as MovieIcon,
  ArrowBack,
} from "@mui/icons-material";
import { Link, useHistory } from 'react-router-dom';
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGetActorDetailQuery, useGetMoviesByActorIdQuery } from '../../services/TMDB';
import useStyle from "./Styles";
import { MovieList, Pagination } from '..';
const Actor = () => {
  const { id } = useParams();
  const classes = useStyle();
  const { data, isFetching, error } = useGetActorDetailQuery(id);
  const [page, setPage] = useState(1);
  const history = useHistory();
  const { data: movies } = useGetMoviesByActorIdQuery({ id, page }) 
  console.log('d', movies);
  if (isFetching) {
    return (
      <Box display="flex" justifyContent="center">
        <CircularProgress size='5rem' />
      </Box>
    )
  }

    if (error) {
      return (
        <Box display='flex' justifyContent='center' alignItems='center' mt="20px">
          <Button startIcon={<ArrowBack />} onClick={() => history.goBack()}>Go Back</Button>
        </Box>
      )
    }
  return (

    <div>
      {data && <>
    <Grid container className={classes.ContinerSpaceAround}>
      
        <Grid item sm={12} lg={4}>
          <img className={classes.poster} src={`https://image.tmdb.org/t/p/w500/${data.profile_path}`} alt={data.name} />
        </Grid>
        <Grid item container direction="column" lg="7">
          <Typography variant="h3" align="left" gutterBottom>
            {data.name}
          </Typography>
          <Typography variant="h5" align="left" gutterBottom>
            {new Date(data.birthday).toDateString()}
          </Typography>

        
          <Typography style={{ marginTop: "10px", marginBottom:'2rem' }} color="textPrimary">
            {data.biography}
          </Typography>
         


           <Grid item container style={{ marginTop: "2rem" }}>
        <div className={classes.buttonContainer}>
          <Grid item xs={12} sm={6}>
            <ButtonGroup size="small" variant="outlined">

              <Button target="_blank" color='primary' variant='contained' rel="noopener noreferrer" href={`https://www.imdb.com/name/${data.imdb_id}`} endIcon={<MovieIcon />}>IMDB</Button>
            </ButtonGroup>
          </Grid>

          <Grid item>
            <ButtonGroup size="small" variant="outlined"> 
              <Button onClick={() => { }} color='primary' variant='contained' sx={{ borderColor: 'Primary.main' }} href='#' endIcon={<ArrowBack />}>
                <Typography style={{textDecoration:'none'}} component={Link} to='/' color="inherit" variant="subtitle2">Back</Typography>
              </Button>

            </ButtonGroup>

          </Grid>
        </div>
      </Grid> 
        </Grid>
        </Grid>
      <Box margin='2rem 0'>
        <Typography variet="h2" gutterBottom align='center'>Movies</Typography>
        {movies && <MovieList movies={movies} />}
    
        <Pagination currentpage={page} setPage={setPage} totalPages={movies && movies.total_pages} />
        </Box>
    
        </>}
     
      </div>

   

    // <div className='mt-20'>
    //   {data && <>
    //   <h1>{data.name}</h1>
    //     <img  src={`https://image.tmdb.org/t/p/w500/${data.profile_path}`} alt={data.name} />
    //   <p>{data.biography}</p>
    //   <p>{new Date(data.birthday).toDateString()}</p>
    //   </>}
    // </div>
  )
}

export default Actor